module.exports = __webpack_public_path__ + "media/images/bindingAccount/icon_line-315a25eda1a55d645d7704021325c32d.svg";